export default "__VITE_ASSET__BCh24NCm__"